import React, { useEffect, useState } from "react";
import { Tabs, Divider, Form, Button } from "antd";
import EnderecoForm from "./Base/EnderecoForm";
import PessoaForm from "./Base/PessoaForm";
import PessoaEnderecos from "./Base/PessoaEnderecos";
const { TabPane } = Tabs;

export default function ClienteDetalhe({ cliente, setCliente, jump, ...props }) {
  const [form] = Form.useForm();
  const [key, setKey] = useState("1");
  const [pessoaTabIndex, setPessoaTabIndex] = useState(null);

  useEffect(() => {
    if (jump)
      setKey("2");
  }, []);

  return <div style={{ maxWidth: 1000, margin: "0 auto" }}>
    <Form form={form} onKeyPress={e => e.key === "Enter" && e.preventDefault()} initialValues={cliente} onFinish={() => props.onOk()}>
      <Tabs activeKey={key} onChange={setKey}>
        <TabPane forceRender tab="Principal" key="1">
          <PessoaForm tabIndex={25} object={cliente} setObject={v => { setCliente(v); form.setFieldsValue(v); }} setTabIndexExterno={setPessoaTabIndex} tipoPlanoConta="cr" hasTipo />
          <Divider orientation="left">Endereço</Divider>
          <EnderecoForm tabIndex={pessoaTabIndex + 1} object={cliente} setObject={endereco => { setCliente({ ...cliente, ...endereco }); form.setFieldsValue({ ...cliente, ...endereco }); }} />
        </TabPane>

        <TabPane forceRender tab="Endereços" key="2">
          <PessoaEnderecos enderecos={cliente.enderecos} setEnderecos={es => setCliente({ ...cliente, enderecos: es })} tabIndex={50} />
        </TabPane>

      </Tabs>
      <Button id="btnFinalizarHide" htmlType="submit" style={{ display: 'none' }} />
    </Form>
  </div >;
}